export default "__VITE_ASSET__c1c0bd21__"